/**
 * A component that renders a small "load history" badge at the top of the conversation.
 */
import React from "react";
import { connect } from "react-redux";

import styled from "styled-components";

import { getMessagesHistory } from "../store";
import { deepChange } from "../actions";
import { converstationHistoryKey } from "../lib/constants";
import { UserEventsAPI } from "../lib/userEventsAPI";
import type { GlobalState } from "../lib/types";

/**
 * HistoryHandler component.
 */
class HistoryHandler extends React.Component {
  /**
   * Load messages history from the local storage.
   */
  loadHistory = () => {
    const { dispatch, messagesHistory } = this.props;
    let messages = JSON.parse(localStorage.getItem(converstationHistoryKey) || "[]");
    messages = messages.map((message) => {
      return { ...message, fromHistory: true };
    });
    const knownTimestamps = messagesHistory.map((m) => m.timestamp);
    messages = messages.filter((m) => !knownTimestamps.includes(m.timestamp));

    dispatch(
      deepChange({
        path: "messagesHistory",
        value: [...messages, ...messagesHistory],
      })
    );
    dispatch(deepChange({ path: "localHistoryLoaded", value: true }));
    dispatch(UserEventsAPI.sendHistoryOpened());
  };

  render() {
    const { localHistoryLoaded, localHistoryExists } = this.props;

    if (localHistoryLoaded || !localHistoryExists) {
      return null;
    }
    return (
      <LoadMore onClick={this.loadHistory}>
        <div className="text">Load History</div>
      </LoadMore>
    );
  }
}

export const LoadMore = styled.div`
  position: relative;
  text-align: center;
  margin: 0 0 25px;
  width: 100%;

  .text {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 0 2px 0 rgba(0, 0, 0, 0.14);
    font-size: 11px;
    line-height: 11px;
    font-weight: 500;
    color: #3a3a3c;
    position: relative;
    z-index: 1;
    display: inline-block;
    cursor: pointer;
    border-radius: 5px;
    background-color: #fff;
    padding: 5px;
    margin: 5px 0 4px;

    &:hover {
      box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
    }
  }
`;

/**
 * Map state to props.
 */
function mapStateToProps(state: GlobalState, ownProps) {
  return {
    ...ownProps,
    messagesHistory: getMessagesHistory(state),
    localHistoryLoaded: state.localHistoryLoaded,
    localHistoryExists: state.localHistoryExists,
  };
}

export default connect(mapStateToProps)(HistoryHandler);
